import { Kaggle } from "@kaggle/sdk";
import { getServices } from "../../../../api/getServices";
import TerminalError from "../../../types/TerminalError";
import TerminalMessage from "../../../types/TerminalMessage";
import { getUserId } from "../../selectors/user";
import { getStore } from "../../store/appStore";
import { setCollaborators, setOwner } from "../notebook";
import { appendTerminal } from "../terminal";

export const updateCollaborators = async (
  collaborators: Kaggle.Sdk.Users.Models.Collaborator[]
) => {
  const state = getStore().getState();

  const kernelId = state.notebook.kernel;
  if (!kernelId) {
    throw new Error("Kernel ID can't be null.");
  }

  const viewerId = getUserId(state);
  if (!viewerId) {
    throw new Error("Viewer ID can't be null.");
  }

  try {
    // NOTE: Not sure why this type is needed but tsc complains
    // if we don't use it in the explicit casts below.
    type CollaboratorType = "owner" | "reader" | "writer";

    const request = {
      kernelId,
      collaborators: {
        collaborators,
        owner: {
          userId: viewerId,
          isGroup: false,
          isUser: true,
          type: "owner" as CollaboratorType,
          groupId: null,
          groupMemberCount: null,
          profileUrl: "",
          thumbnailUrl: "",
          name: "",
          slug: "",
          userTier: null,
          joinDate: null,
        },
      },
    };

    await getServices().kernelsClient.updateKernelCollaborators(request);
    setCollaborators(collaborators);
  } catch (error) {
    appendTerminal([
      new TerminalMessage("An error occurred updating collaborators."),
      new TerminalError(error),
    ]);
    throw error;
  }
};

/** Fetch collaborators from backend and populate Redux. */
export const fetchCollaborators = async () => {
  const state = getStore().getState();
  const kernelId = state.notebook.kernel;
  if (kernelId === null) {
    throw new Error("fetchCollaborators requires kernelId.");
  }

  const response = await getServices().kernelsClient.getKernelCollaboratorList({
    kernelId,
    alwaysIncludeReadGroup: false,
  });

  setCollaborators(response.collaboratorList.collaborators);
  setOwner(response.collaboratorList.owner);
};
